import throttle from 'lodash.throttle';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
export const getLeftPositioningValue = ({ ref, index }) => {
    var _a;
    if (!ref.current)
        return 0;
    let size = 0;
    let node = ref.current;
    while (node.previousElementSibling instanceof HTMLElement &&
        ((_a = node.previousElementSibling.dataset) === null || _a === void 0 ? void 0 : _a.index) &&
        index > Number(node.previousElementSibling.dataset.index)) {
        size += node.previousElementSibling.offsetWidth;
        node = node.previousElementSibling;
    }
    return size;
};
const getRightPositioningValue = ({ ref, index }) => {
    var _a;
    if (!ref.current)
        return 0;
    let size = 0;
    let node = ref.current;
    while (node.nextElementSibling instanceof HTMLElement &&
        ((_a = node.nextElementSibling.dataset) === null || _a === void 0 ? void 0 : _a.index) &&
        index < Number(node.nextElementSibling.dataset.index)) {
        size += node.nextElementSibling.offsetWidth;
        node = node.nextElementSibling;
    }
    return size;
};
export const useStickyCell = (args) => {
    const { ref, index, pinnedPosition } = args;
    const [position, setPosition] = useState(0);
    const setStickyStyles = useCallback(() => {
        if (!pinnedPosition)
            return;
        const newPosition = pinnedPosition === 'left'
            ? getLeftPositioningValue({ ref, index })
            : getRightPositioningValue({ ref, index });
        if (newPosition !== position)
            setPosition(newPosition);
    }, [pinnedPosition, position, index, ref]);
    useEffect(() => {
        const throttledFn = throttle(setStickyStyles, 200, { trailing: true });
        window.addEventListener('resize', throttledFn);
        return () => window.removeEventListener('resize', throttledFn);
    }, [setStickyStyles]);
    useLayoutEffect(() => {
        setStickyStyles();
    }, [setStickyStyles]);
    return pinnedPosition ? { [pinnedPosition]: position } : {};
};
//# sourceMappingURL=useStickyCell.js.map